import DeleteIcon from "@mui/icons-material/Delete";
import { IconButton } from "@mui/material";
import _ from "lodash";
import React, { useCallback, useContext, useState } from "react";
import GlobalContext from "../../framework/GlobalContext";
// import NumberInput from "../../framework/NumberInput"; // kept for commented code below
import SelectInput from "../../framework/SelectInput";
import { searchGlobalMedicine } from "../../services/medicine-services";

const AddIngredients = (props) => {
  const {
    index,
    ingredient,
    showDeleteIcon = true,
    onDeleteIngredient = () => {},
    onChange = () => {},
  } = props;

  const { setCurrentComponent } = useContext(GlobalContext);

  const [medicineOptions, setMedicineOptions] = useState([]);

  const getMarker = useCallback(
    (direction, rowItemIndex, rowIndex) => {
      switch (direction) {
        case "right":
          // With only the name field active, move to next row's name if present
          if (document.getElementById(`row_item_0_${index + 1}`)) {
            return `row_item_0_${index + 1}`;
          }
          return `row_item_0_${index}`;
        case "left":
          // Move to previous row's name if present
          if (document.getElementById(`row_item_0_${index - 1}`)) {
            return `row_item_0_${index - 1}`;
          }
          return `row_item_0_${index}`;
        case "up":
          return `row_item_0_${rowIndex}`;
        case "down":
          return `row_item_0_${rowIndex}`;
        default:
          return `row_item_0_${rowIndex}`;
      }
    },
    [index]
  );

  const searchMedicine = useCallback(async (searchTerm) => {
    if (searchTerm?.length > 2) {
      await searchGlobalMedicine(
        `search=${searchTerm.replace(" ", "")}&isRecipe=false`
      ).then((response) => {
        const result = response?.result.map((medicineData) => {
          return {
            id: medicineData.medicineId,
            label: medicineData.medicineNameDetailed,
            medicineName: medicineData.medicineName,
            medicinePackaging: medicineData.medicinePackaging,
          };
        });
        setMedicineOptions(result);
      });
    }
  }, []);

  //  eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceSearchMedicine = useCallback(
    _.debounce(searchMedicine, 300, { leading: true }),
    []
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        justifyContent: "space-between",
      }}
    >
      <div style={{ flex: 5 }}>
        <SelectInput
          id={`row_item_0_${index}`}
          autoFocus
          label="Ingredient Name"
          onFocus={() => {
            setCurrentComponent("add_ingredient_name");
          }}
          getOptionLabel={(option) => option.label || option}
          isOptionEqualToValue={(option, value) => {
            return option?.label === value.label || value === "";
          }}
          options={medicineOptions}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.label}
              </li>
            );
          }}
          value={ingredient?.name}
          onInputChange={(e, value) => {
            //   removeErrorState("productName");
            debounceSearchMedicine(value);
          }}
          onChange={(e, value) => {
            onChange("name", value);
            onChange("itemMedicineId", value?.id);
            onChange("medicinePackaging", value?.medicinePackaging);
          }}
          markers={JSON.stringify({
            up: getMarker("up", 0, index),
            down: getMarker("down", 0, index),
            left: getMarker("left", 0, index),
            right: getMarker("right", 0, index),
          })}
        />
      </div>
      {/**
       * <div style={{ flex: 2 }}>
       *   <NumberInput
       *     id={`row_item_1_${index}`}
       *     label="Pack Qty"
       *     decimalScale={0}
       *     value={ingredient?.quantity}
       *     inputStyle={{
       *       background: "lightblue",
       *       flex: 1,
       *     }}
       *     onChange={(e) => onChange("quantity", +e.target.value)}
       *     inputProps={{
       *       "data-markers": JSON.stringify({
       *         up: getMarker("up", 1, index),
       *         down: getMarker("down", 1, index),
       *         left: getMarker("left", 1, index),
       *         right: getMarker("right", 1, index),
       *       }),
       *     }}
       *   />
       * </div>
       */}
      <span style={{ flex: 1 }}>{ingredient?.medicinePackaging}</span>
      {/**
       * <div style={{ flex: 2 }}>
       *   <NumberInput
       *     id={`row_item_2_${index}`}
       *     label="Loose Qty"
       *     decimalScale={0}
       *     value={ingredient?.loose}
       *     onChange={(e) => onChange("loose", +e.target.value)}
       *     inputProps={{
       *       "data-markers": JSON.stringify({
       *         up: getMarker("up", 2, index),
       *         down: getMarker("down", 2, index),
       *         left: getMarker("left", 2, index),
       *         right: getMarker("right", 2, index),
       *       }),
       *     }}
       *   />
       * </div>
       */}
      <span style={{ flex: 1 }}>{ingredient?.divisorUnit}</span>
      {showDeleteIcon && (
        <IconButton onClick={() => onDeleteIngredient(index)}>
          <DeleteIcon />
        </IconButton>
      )}
    </div>
  );
};

export default AddIngredients;
